module.exports = __webpack_public_path__ + "img/jingyingbang-wuliu.d31bbde4.png";